import { createFileRoute } from '@tanstack/react-router';
import { MovementForm } from '@/pages/accounts/form-movement';
import { FORECAST, PROTECTED } from '@/lib/constants/routes';

export const Route = createFileRoute(
  '/protected/_layout/forecast/_layout/cash-movement/$id'
)({
  component: EditMovementModal,
});

function EditMovementModal() {
  const { id } = Route.useParams();

  return <MovementForm id={id} returnUrl={`${PROTECTED}${FORECAST}`} />;
}
